<template>
  <div style="padding-top: 20px;text-align:center;">
    <h4>Oops, it looks like the page you're looking for doesn't exist.</h4>
  </div>
</template>
